
import { Options, Prop, Vue, Watch } from "vue-property-decorator";
import * as api from "@/api/safecheck";

@Options({})
export default class extends Vue {
  private flag = false;
  private show = false;
  private personName = "";
  private refreshing = false;
  private checkList: any[] = [];
  private loading = false;
  private finished = false;
  private result = { name: "", userId: "" };
  private fieldValue = "";

  @Watch("personName")
  onPersonNameChanged(newValue: string, oldValue: string) {
    this.refreshing = true;
    this.onRefresh();
  }

  @Watch("result")
  onResultChanged(newValue: string, oldValue: string) {
    this.flag = true;
  }

  protected showPopup() {
    this.show = true;
  }

  protected onLoad() {
    setTimeout(() => {
      if (this.refreshing) {
        this.checkList = [];
        this.refreshing = false;
      }
      api
        .pageListUser({
          pageNum: parseInt(this.checkList.length / 20 + "") + 1,
          pageSize: 20,
          projectId: this.$store.state.project.projectinfo.projectId,
          name: this.personName,
        })
        .then((res) => {
          this.checkList = [...this.checkList, ...res.data.records];
          this.loading = false;
          if (this.checkList.length >= res.data.total) {
            this.finished = true;
          }
        });
    }, 500);
  }

  protected onFinish() {
    this.show = false;
    this.fieldValue = this.result.name;
    let checkUser = { id: this.result.userId, name: this.result.name };
    this.$emit("selected", checkUser);
  }

  onRefresh() {
    this.finished = false;
    this.loading = true;
    this.onLoad();
  }
}
